// @flow
import * as React from 'react';
import { getUiBrowser, isUiMobile } from '../../redux/modules/browser';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getBaseUrl } from '../../redux/modules/config';
import { getLiveBiddingUrl } from '../../utils/urls';
import { getLocale } from '../../redux/modules/intl';
import isEqual from 'react-fast-compare';
import { popupCenter } from '../../utils/popupCenter';
import { push } from 'connected-react-router';

const mapStateToProps = state => {
    const locale = getLocale(state);
    const baseUrl = getBaseUrl(state);
    const mobile = isUiMobile(state);
    const browser = getUiBrowser(state);
    const localePath = locale === 'en-gb' ? `/${locale}` : '';
    return { baseUrl, browser, localePath, mobile };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            push,
        },
        dispatch
    );

type Props = {
    catalogId: number,
    children: React.Node,
    localePath: string,
    mobile: string,
    push: Function,
};

class BidConsoleOpener extends React.Component<Props> {
    static defaultProps = {
        catalogId: 0,
        children: '',
        localePath: '',
        mobile: '',
    };

    shouldComponentUpdate = nextProps => !isEqual(this.props, nextProps);

    goToLiveBidding = catalogId => {
        this.props.push({
            pathname: this.props.localePath + getLiveBiddingUrl(catalogId),
        });
    };

    openBidConsole = event => {
        const { catalogId, localePath, mobile } = this.props;

        if (mobile || event.shiftKey) {
            this.goToLiveBidding(catalogId);
        } else {
            popupCenter(localePath + getLiveBiddingUrl(catalogId), '', 1024, 720);
        }
    };

    render() {
        return React.cloneElement(React.Children.only(this.props.children), {
            onClick: this.openBidConsole,
        });
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BidConsoleOpener);
